<div class="container-fluid mt-4">
  <div class="row gy-4">
    <!-- Left Section -->
    <div class="col-12 col-lg-7 col-md-12">
      <div class="card p-3 mb-4" [class.disabled-overlay]="isLoading">
        <h5 class="section-title fs-6 mb-3">Share Announcement</h5>

        <div class="input-box">
          <form [formGroup]="announcementForm">
            <textarea
              class="form-control"
              type="text"
              formControlName="content"
              placeholder="Write your announcement or study material description here..."
            ></textarea>
          </form>

          <div class="attached-resources" *ngIf="links.length > 0">
            <div class="chip" *ngFor="let link of links; let i = index">
              <i class="bi bi-link"></i>
              <a
                [href]="link"
                target="_blank"
                [title]="link"
                class="truncate-url"
                >{{ link }}</a
              >
              <button type="button" class="delete-btn" (click)="removeUrl(i)">
                <i class="bi bi-trash-fill text-danger"></i>
              </button>
            </div>
          </div>

          <div class="attached-resources" *ngIf="uploadedImages.length > 0">
            <div class="chip" *ngFor="let item of uploadedImages">
              <i class="bi bi-file-earmark-text"></i>
              <span>{{ item.file.name }}</span>
              <button
                type="button"
                class="delete-btn"
                (click)="removeImage(item)"
              >
                <i class="bi bi-trash-fill text-danger"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-between">
          <div class="dropdown custome-dropdown mt-2" #dropdownContainer>
            <span class="me-2 fw-medium">For</span>
            <button class="dropbtn" (click)="toggleDropdown()">
              <ng-container
                *ngIf="selectedClassroom.length === 1; else mutlipClassSelected"
                >{{ selectedClassroomName }}</ng-container
              >
              <ng-template #mutlipClassSelected
                >{{ selectedClassroom.length }} classes
              </ng-template>
              <!-- <i
                class="bi ms-3"
                [ngClass]="isOpen ? 'bi-chevron-up' : 'bi-chevron-down'"
              ></i> -->
            </button>
      <!-- we are not using this api for now as we are not sharing announcement to multiple classrooms now
             <div class="dropdown-content" *ngIf="isOpen" #dropdownPopup>
              <label
                *ngFor="let _className of _classroom"
                [class.default-classroom]="_className.id === currentClassroomId"
              >
                <input
                  type="checkbox"
                  [value]="_className.id"
                  (change)="onSelect($event, _className.id)"
                  [checked]="selectedClassroom.includes(_className.id)"
                  [disabled]="_className.id === currentClassroomId"
                />
                {{ _className.name }}
              </label>
            </div> -->
          </div>

          <div class="text-end d-flex mt-2">
            <label class="me-2">
              <img
                src="assets/images/upload.png"
                matTooltip="Use urls"
                (click)="openAddLinkDialogBox(_MaterialFileUpload.WEBSITE_URL)"
              />
            </label>
            <label class="me-2">
              <img
                src="assets/images/link.png"
                matTooltip="Use File"
              />
              <input
                #fileInput
                type="file"
                accept="*/*"
                (change)="onFileSelected($event)"
                hidden multiple
              />
            </label>
            <button
              class="btn btn-share d-flex align-items-center"
              (click)="postShareMaterial()"
              [disabled]="isLoading"
            >
              <img
                src="assets/images/share.png"
                alt="share-icon"
                class="me-1"
              />
              <div class="btn-content d-flex align-item-center">
                <mat-spinner
                  *ngIf="isLoading"
                  diameter="25"
                  strokeWidth="3"
                  class="spinner-white me-2"
                ></mat-spinner>
                <span>{{ isLoading ? "Sharing..." : "Share" }}</span>
              </div>
            </button>
          </div>
        </div>
      </div>

	   <ng-container *ngIf="isAnnouncement">
         <div class="app-spinner">
            <mat-spinner></mat-spinner>
         </div>
       </ng-container>

   <ng-container *ngIf="_topStudyMaterial.length === 0 && !isAnnouncement">
        <div class="card p-3 mb-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="section-title fs-6">Recent Announcement</h5>
            <i class="bi bi-arrow-right"></i>
          </div>

          <div class="d-flex justify-content-center">
            <img src="assets/images/noAnnouncement.png" alt="No Announcement" />
          </div>
          <span class="text-center mt-3">No announcement yet</span>
        </div>
   </ng-container> 


      <ng-container *ngIf="_topStudyMaterial.length > 0 && !isAnnouncement">
       <div class="card p-3 mb-4">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="section-title fs-6">Recent Announcement</h5>
            <i class="bi bi-arrow-right"></i>
          </div>
        <div
          *ngFor="let studyMaterial of _topStudyMaterial"
          class="announcement-post mb-3  p-3">
          <div class="d-flex align-items-center mb-2 justify-content-between">
            <div class="d-flex align-items-center">
              <img
                src="assets/images/avatar.png"
                alt="profile"
                class="avatar me-2"
              />
              <div class="text-start">
                <strong>{{ studyMaterial.teacher_name }}</strong>
                <div class="text-muted small">
                  {{ convertToIST(studyMaterial.created_at) }}
                </div>
              </div>
            </div>
            <div class="text-end">
              <button [matMenuTriggerFor]="menu" class="plain-icon">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="openEditPopup(studyMaterial)">
                  Edit
                </button>
                <button
                  mat-menu-item
                  (click)="openDeleteDialogBox(studyMaterial.id)"
                >
                  Delete
                </button>
              </mat-menu>
            </div>
          </div>
          <!-- edit -->
          <div
            *ngIf="currentPopup === studyMaterial.id"
            class="popup"
            (click)="closePopup($event)"
          >
            <div (click)="$event.stopPropagation()">
              <form [formGroup]="editAnnouncementForm">
                <textarea
                  formControlName="content"
                  class="form-control announcement-textarea"
                ></textarea>
                <div class="text-end mb-2">
                  <button
                    type="button"
                    class="btn-cancel py-2 me-2"
                    (click)="closePopup()"
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    (click)="updateAnnouncement()"
                    class="btn-add"
                    [disabled]="editAnnouncementForm.invalid"
                  >
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div class="mb-2 fs-6" *ngIf="currentPopup !== studyMaterial.id">
            {{ studyMaterial.content }}
          </div>

		<div *ngIf="studyMaterial.materials.length > 0">
		<div *ngFor="let material of studyMaterial.materials" class="mb-2">
         <ng-container *ngIf="material.is_material_file">
    <a
      *ngIf="material.original_file_s3_url; else fileReadyOnly"
      [href]="material.original_file_s3_url"
      target="_blank"
      rel="noopener noreferrer"
      class="pdf-bg mb-2 me-2"
    >
      <i class="bi bi-file-earmark-pdf"></i>
      {{material.material_name }}
    </a>

    <ng-template #fileReadyOnly>
      <span *ngIf="material.extracted_file_s3_url" class="pdf-bg pdf-disabled mb-2">
        <i class="bi bi-file-earmark-pdf"></i>
        {{ material.material_name }}
      </span>
    </ng-template>
        </ng-container>
  <a *ngIf="material.original_website_url"
    [href]="material.original_website_url"
    target="_blank"
    rel="noopener noreferrer"
    class="pdf-bg">
    <i class="bi bi-link-45deg"></i>
    {{ material.original_website_url }}
  </a>
 </div>
        </div>
		</div>
		</div>
      </ng-container>
    </div>

    <!-- Right Section -->
    <div class="col-12 col-lg-5 col-md-12">
      <div class="card mb-4">
        <h5 class="section-title mb-3 fs-6">Create with AI in a Click</h5>
        <div class="row g-3">
          <!-- Create Course -->
          <div class="col-12 col-sm-6">
            <button
              class="btn-task w-100"
              (click)="showCourseCreationModal = true"
            >
              <span class="icon-wrapper bg-green">
                <i class="right-card-icons bi bi-book text-light"></i>
              </span>
              Create Course
            </button>
          </div>

          <!-- Create Quiz -->
          <div class="col-12 col-sm-6">
            <button class="btn-task w-100" (click)="openModel($event)">
              <span class="icon-wrapper bg-blue">
                <i class="right-card-icons bi bi-bag-check text-light"></i>
              </span>
              Create Quiz
            </button>
          </div>

          <!-- Modal -->
          <div
            class="custom-modal-backdrop"
            *ngIf="showModal"
            (click)="closeModal()"
          >
            <div class="custom-modal" (click)="$event.stopPropagation()">
              <form [formGroup]="quizForm">
                <div class="modal-header">
                  <h4 class="create-account">Create New Quiz</h4>
                  <button class="close-btn" (click)="closeModal()"></button>
                </div>

                <div class="modal-body">
                  <label for="quizTitle" class="fw-bold">Quiz Title</label>
                  <input id="quizTitle" class="quiz-input mb-3" type="text" formControlName="quiz_name"
                    placeholder="Enter Your Quiz Title" />


                  <label for="quizTitle" class="fw-bold">Time Limit</label>
                  <div class="time-limit-section">
                    <div class="time-inputs">
                      <div class="time-field mb-2">
                        <input
                          type="number"
                          min="0"
                          placeholder="00"
                          formControlName="hours"
                        />
                        <span>Hrs</span>
                      </div>
                      <div class="time-field mb-2">
                        <input
                          type="number"
                          min="0"
                          placeholder="00"
                          max="60"
                          formControlName="minutes"
                        />
                        <span>Min</span>
                      </div>
                      <div class="time-field mb-2">
                        <input
                          type="number"
                          min="0"
                          placeholder="00"
                          max="60"
                          formControlName="seconds"
                        />
                        <span>Sec</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="modal-footer pt-2">
                  <button class="cancel-btn" (click)="closeModal()">
                    Cancel
                  </button>
                  <button
                    class="continue-btn"
                    (click)="createQuiz()"
                    [disabled]="quizForm.invalid || isCreating">
					<ng-container *ngIf="!isCreating; else creating">
                    Create Quiz</ng-container>
					<ng-template #creating>
			        <span class="spinner-text">
			          <mat-spinner [diameter]="20" class="spinner-white"></mat-spinner>Creating...</span>
			        </ng-template>
                  </button>
                </div>
              </form>
            </div>
          </div>

          <!-- Create Assignment -->
          <div class="col-12 col-sm-6">
            <button class="btn-task-inactive w-100" [disabled]="true" matTooltip="Coming Soon" matTooltipPosition="above">
              <span class="icon-wrapper"> <!-- add-purple-purple-->
                <i class="right-card-icons bi bi-journal-check text-light"></i>
              </span>
              Create Assignment
            </button>
          </div>

          <!-- Create Question Paper -->
          <div class="col-12 col-sm-6 mb-2">
            <button class="btn-task-inactive w-100" [disabled]="true" matTooltip="Coming Soon" matTooltipPosition="above">
              <span class="icon-wrapper"> <!-- add-purple-orange-->
                <i class="right-card-icons bi bi-journal-medical text-light"></i>
              </span>
           <div class="button-text">Create Question Paper</div>
             </button>
          </div>
        </div>
      </div>

      <!-- Upcoming Dues -->
      <div class="card p-3 mb-4">
        <div class="d-flex text-start section-title fs-6">
          <i class="bi bi-clock me-2"></i> Upcoming Dues
        </div>
        <div class="d-flex justify-content-center mt-3">
          <img src="assets/images/noReceived.png" alt="No Announcement" />
        </div>
        <span class="text-center mt-3">No Dues</span>
      </div>
    </div>
  </div>
</div>

<!-- Modal (unchanged) -->
<div
  class="modal-backdrop"
  *ngIf="showCourseCreationModal"
  (click)="closeModal()"
>
  <div class="modal-container" (click)="$event.stopPropagation()">
    <button class="close-btn" (click)="closeModal()">
      <i class="bi bi-x"></i>
    </button>
    <h3 class="modal-title">Choose Course Creation Type</h3>
    <p class="subtitle">
      Would you like to build your course step-by-step, or let AI help you
      generate one instantly?
    </p>

    <div class="card-container">
      <!-- Manual Creation -->
      <div class="option-card">
        <div class="icon-purple">
          <img class="icon" src="assets/images/note.svg" alt="Manual Icon" />
        </div>
        <h5>Manual Creation</h5>
        <ul>
          <li>
            Step-by-step creation – ideal if you already have your syllabus.
          </li>
          <li>
            You’ll add your course details, objectives, and units manually.
          </li>
        </ul>
        <button class="option-btn" (click)="goToCoursePage()"> Manual Creation </button>
      </div>

      <!-- AI Generation -->
      <div class="option-card">
        <div class="icon-purple">
          <img class="icon" src="assets/images/robot.svg" alt="AI Icon" />
        </div>
        <h5>AI-Powered Generation</h5>
        <ul>
          <li>
            Let AI generate your complete course structure with just one line!
          </li>
          <li>
            Enter a short description and AI will create the structure for you.
          </li>
        </ul>
        <button class="option-btn" (click)="generateWithAI()">
          Generate With AI
          <img class="create-icon" src="assets/images/ai01.svg" alt="AI Icon" />
        </button>
      </div>
    </div>
  </div>
</div>
